import MercadoPagoSection from './MercadoPagoSection';
export default MercadoPagoSection;
